import history from './history';
export default history;



// WEBPACK FOOTER //
// ./src/services/history/index.js